import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router, browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';

import configureStore from './store/configureStore';
import routes from './routes';
require('expose?$!expose?jQuery!jquery');
require('bootstrap-webpack');

const store = configureStore();
const history = syncHistoryWithStore(browserHistory, store);



ReactDOM.render(
    <Provider store={store}>
        <Router history={history}>
            {routes}
        </Router>
    </Provider>,
    document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js